<template>
  <div
    :key="plan?.title"
    :class="['flex flex-col items-center rounded-2xl px-4 py-6 relative']"
    :style="
      !selected && plan?.best
        ? {
            backgroundColor: '#F8FEFA',
            border: '1px solid #2A8176',
          }
        : { boxShadow, border: '1px solid transparent' }
    "
  >
    <div
      v-if="!selected && plan?.best"
      :class="[
        'absolute won-green-background-color rounded-full h-6',
        'flex items-center justify-center text-white text-xs font-semibold',
      ]"
      style="width: 136px; top: -12px"
    >
      Best Value
    </div>

    <div class="text-base font-medium won-color-subtitle-gray">
      {{ plan?.title }}
    </div>

    <div class="flex items-center justify-center mt-2.5">
      <div style="font-size: 40px" class="won-blue font-medium">
        +{{ plan?.amount }}
      </div>

      <won-coin class="ml-2 w-9 h-9" />
    </div>

    <div class="text-center text-sm mt-1.5" style="color: #505d68">
      <div>{{ plan?.description }}</div>
      <div>{{ plan?.points }}</div>
    </div>

    <div
      class="w-full h-px won-gray-background-color"
      style="margin-top: 14px; margin-bottom: 7px"
    />

    <div style="color: #505d68" class="text-2xl font-medium">
      for&nbsp;${{ plan?.cost }}
    </div>

    <div
      v-if="selected"
      :class="[
        'w-full h-9 flex items-center justify-center rounded',
        'won-light-green-background-color mt-5',
      ]"
    >
      <checked class="mr-2.5" />
      <div class="text-sm won-color-green font-semibold">Selected</div>
    </div>

    <div
      v-else
      :class="[
        'w-full rounded h-9 flex items-center justify-center',
        'text-sm font-semibold mt-5 cursor-pointer',
        !selected && plan?.best
          ? 'text-white won-green-background-color'
          : 'won-color-green',
      ]"
      style="border: 1px solid #2a8176"
      @click="() => $emit('option:select', plan)"
    >
      Purchase Package
    </div>
  </div>
</template>

<script>
import WonCoin from '../../icons/won-coin.vue'
import Checked from '../../icons/checked.vue'

export default {
  components: { WonCoin, Checked },

  props: {
    plan: {
      type: Object,
      default: () => ({}),
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['option:select'],

  data: () => ({
    boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.1)',
  }),
}
</script>

<style>
</style>
